import React, { useState, useEffect, useRef, useMemo } from "react";
import Autocomplete from "react-autocomplete";
import DatHangApi from "../../../service/DatHang/DatHangApi";
import { getBranch } from "utils/utils";
import moment from "moment";

export const AutocompleteSanPham = ({
    setCategoryNow,
    value,
    setValue,
    StoreID,
    dataBanHang,
    setCheckSPBanTTK,
    setGetCategoryID,
    disEditAll,
    IsFocusTenSanPham,
    setFocusTenSanPham,
    setFocusChonSanPham,
    BranchID,
}) => {
    const textInput = useRef();
    const [sanPhamVuaThem, setSanPhamVuaThem] = useState({});
    const [valueInterval, setValueInterval] = useState(0);
    const [valueBur, setValueBur] = useState(false);
    const [autocompleteData1, setAutocompleteData1] = useState([]);
    useEffect(() => {
        //alert('hehe');
        if (disEditAll === true) {
            setAutocompleteData1([]);
        } else {
            async function fetchMyAPI() {
                var sSearch = "";
                const param2 =
                    //= "?sSearch=" + sSearch;
                    "?sSearch=" +
                    sSearch +
                    "&brandId=" +
                    BranchID +
                    "&storeId=0" +
                    "&getMaCuon=true";
                const tukhoa = {
                    params: param2,
                };
                const response = await DatHangApi.AutocompleteSanPham.call(
                    null,
                    tukhoa
                );

                if (response.data !== null) {
                    setAutocompleteData1(response.data);
                } else {
                    setAutocompleteData1([]);
                }
            }
            fetchMyAPI();
        }
    }, []);
    if (IsFocusTenSanPham) {
        textInput.current.focus();
        setFocusTenSanPham(false);
    }

    const plusEnter = (event) => {
        var val = event.target.value;
        if (
            val === "+" &&
            typeof sanPhamVuaThem != "undefined" &&
            sanPhamVuaThem.CategoryID > 0
        ) {
            onSelectCustomer(sanPhamVuaThem.CategoryName, sanPhamVuaThem);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            plusEnter(e);
        }
        if (e.key === "Tab") {
            setValueBur(true);
        }
    };
    const onSelectCustomer = (value, item) => {
        setValue(value);
        setSanPhamVuaThem(item);
        setGetCategoryID(item.CategoryID);
        DatHangApi.getChiTietSanPhamById(
            item.CategoryID,
            StoreID,
            BranchID,
            dataBanHang.CustomerID,
            moment(dataBanHang.CreatedTime).format("YYYY/MM/DD HH:mm:ss")
        ).then((response) => {
            response.data.OrderID = 0;
            response.data.SaleTime = dataBanHang.CreatedTime;
            response.data.OrderDetailsID = 0;
            response.data.RateForSale = 1;
            response.data.Quantity = 1;
            response.data.MaCuon = item.IsMaCuon ? item.MaCuon : "";
            response.data.MaCuonNew = "";
            response.data.isNXCuon = item.IsMaCuon ?? false;
            if (item.IsMaCuon) {
                response.data.NoteMaMc = item.NoteMAMC;
                response.data.MaCuon = item.MaCuon;
                response.data.MaCuonNew = item.MaCuon + " - " + item.Remain;
                response.data.ProductID = item.ProductID;
                response.data.OptionID = item.OptionID;
                response.data.SLDonViBan = item.Remain.toString();
            }

            if (dataBanHang.ConfigTruKhoGiaCong === true) {
                response.data.BanThuongMai = true;
            } else {
                response.data.BanThuongMai = false;
            }
            response.data.Price = response.data.ExportPrice;
            response.data.TiTrong = response.data.TiTrong;
            response.data.SLDonViBan = "";
            response.data.PriceOld = response.data.ExportPrice;

            response.data.StoreID = StoreID;
            // response.data.StoreName = item.StoreName;
            response.data.isGiaVon = false;
            response.data.CategoryName = item.CategoryName;
            response.data.CategoryID = item.CategoryID;
            response.data.EditChiTietDonHang = 0;

            response.data.ChietKhau = 0;
            response.data.LoaiChietKhau = 1;
            response.data.NameLoaiChietKhau = "VNĐ";
            if (response.data.LoaiChietKhau === 1) {
                response.data.IsVND = true;
                response.data.IsPercent = false;
                response.data.GiaGoc = response.data.Price - response.data.ChietKhau;
            } else {
                response.data.IsVND = false;
                response.data.IsPercent = true;
                response.data.GiaGoc =
                    response.data.Price -
                    (response.data.Price * response.data.ChietKhau) / 100;
            }
            response.data.IdDonViXuat = response.data.UnitForExportPrice;
            //
            //    const datalstNew =
            //      response.data.Attributes.length > 0 &&
            //      response.data.Attributes.map((row) => {
            //        let item1 = { ...row };
            //        item1.ID = item1.AttributeID;
            //        item1.text = item1.Display;
            //        return item1;
            //      });
            const arr1 = [
                {
                    // ID: data.data.IdDonViNhap,
                    ID: response.data.UnitForExportPrice,
                    CategoryID: 0,
                    Name: response.data.DonViXuat,
                    Ratio: 0,
                    RatioDifferent: 1,
                    RatioMain: 1,
                    SoLuongTraTTk: 1,
                    Values: 1,
                    ValuesDaNhap: 1,
                    isCheck: false,
                    // AttributeID: data.data.IdDonViNhap,
                    AttributeID: response.data.UnitForExportPrice,
                    Display: response.data.TenDonViXuat,
                    ImportOrderDetailsID: 0,
                },
            ];

            const children = arr1.concat(response.data.Attributes);
            if (response.data.Attributes.length > 0) {
                response.data.LstDonViNhap = children;
            } else {
                response.data.LstDonViNhap = [];
            }

            if (response.data.Attributes.length > 0) {
                response.data.AttributesNew = response.data.Attributes;
                const isFound = response.data.Attributes.some((element) => {
                    if (element.IsBanTTK === true) return true;
                    return false;
                });
                setCheckSPBanTTK(isFound);
                const listAttrNew = response.data.Attributes;
                if (isFound && dataBanHang.configThuocTinhKhac === "1") {
                    listAttrNew.map((Attribute, i) => {
                        if (Attribute.IsBanTTK === true) {
                            response.data.IdDonViXuatView = Attribute.AttributeID;
                            //

                            var attrOld = children.find(
                                (e) => e.AttributeID !== Attribute.AttributeID
                            );

                            var attr = children.find(
                                (e) => e.AttributeID === Attribute.AttributeID
                            );

                            if (attr != null) {
                                let index = 0;
                                response.data.Attributes.map((item, i) => {
                                    if (item.AttributeID == Attribute.AttributeID) {
                                        index = i;
                                    }
                                });
                                const List = [...response.data.Attributes];

                                List.splice(index, 1);
                                List.push(attrOld);
                                response.data.Attributes = List;
                                response.data.AttributesNew2 = List;
                                let lstAttrNew = response.data.Attributes.map((item, i) => {
                                    if (item.AttributeID === Attribute.AttributeID) {
                                        item.RatioDifferentView = attr.RatioMain;
                                        item.RatioMainView = attr.RatioDifferent;
                                    } else {
                                        response.data.Price =
                                            (response.data.ExportPrice / attr.RatioDifferent) *
                                            attr.RatioMain;

                                        response.data.GiaGoc = response.data.Price;
                                        response.data.PriceOld = response.data.Price;
                                        item.RatioMainView =
                                            (attr.RatioDifferent / attr.RatioMain) * item.RatioMain;
                                        item.RatioDifferentView = item.RatioDifferent;
                                    }
                                    return item;
                                });

                                response.data.Attributes = lstAttrNew;
                            }
                            //
                        }
                    });
                } else {
                    response.data.IdDonViXuatView = response.data.UnitForExportPrice;
                }
            } else {
                response.data.IdDonViXuatView = response.data.UnitForExportPrice;
            }

            if (response.data.CongThucSanPham === null) {
                response.data.CongThucSanPham = {
                    CongThuc: "",
                    KyHieu: [],
                    CongThucID: 0,
                };

                //

                if (response.data.Options.length > 0) {
                    if (dataBanHang.ConfigChuaGiCong === true) {
                        var lst = response.data.Options.filter((x) => x.OptionID !== 0);
                        if (typeof lst !== "undefined" && lst !== null) {
                            response.data.OptionID = lst[0].OptionID;
                            response.data.Options = lst;
                            response.data.RateForSale = lst[0].RateForSale;
                            if (lst[0].OptionID != "0" || lst[0].OptionID != 0) {
                                response.data.RateForSale = lst[0].RateForSale;
                                response.data.OptionID = lst[0].OptionID;
                                response.data.DonVi = lst[0].DonVi;
                                response.data.ImportPrice = lst[0].ImportPriceOld;
                                response.data.ExportPrice = lst[0].Price;
                                response.data.Price = lst[0].Price;
                                response.data.GiaGoc = lst[0].Price;
                            }
                        }
                    } else {
                        response.data.OptionID = response.data.Options[0].OptionID;
                        response.data.RateForSale = response.data.Options[0].RateForSale;
                        var lst1 = response.data.Options;
                        response.data.Options = lst1;
                    }
                }
                setCategoryNow(response.data);

            } else {
                setCategoryNow(response.data);
            }
            // setFocusChonSanPham(true);
        });
        setAutocompleteData1([]);
    };
    //encodeURIComponent mã hoá ký tự đặc biệt gây lỗi không nhận trong URL: +(%2B),&(%26),=(%3D),?(%3F),#(%23),/(%2F)
    const onChange = (event, value) => {
        const realValue = event.target.value;
        setValue(value);

        var BienDiem = 0;
        for (var i = 1; i < 99999; i++) {
            window.clearInterval(i);
        }
        const interval = setInterval(() => {
            BienDiem++;
            if (BienDiem == 2) {
                async function fetchMyAPI() {
                    var sSearch = "";
                    // const param2 = "?sSearch=" + value;
                    const param2 =
                        //= "?sSearch=" + sSearch;
                        "?sSearch=" +
                        encodeURIComponent(realValue) +
                        "&brandId=" +
                        BranchID +
                        "&storeId=" +
                        StoreID +
                        "&getMaCuon=true";
                    const tukhoa = {
                        params: param2,
                    };
                    const response = await DatHangApi.AutocompleteSanPham.call(
                        null,
                        tukhoa
                    );
                    if (response.data !== null) {
                        setAutocompleteData1(response.data);
                    } else {
                        setAutocompleteData1([]);
                    }
                }
                fetchMyAPI();
            }
        }, 350);
        setValueInterval(interval);
    };

    const addKyTuPhi = () => {
        setValue(value + "Ø");
    };

    const focusinputkhachhang = () => { };
    const unfocusinputkhachhang = () => {
        if (valueInterval) {
            clearInterval(valueInterval);
            setValueInterval(0);
        }
    };
    const getLocations = (e) => {
        let val = e.target.value;
        setValue(val);

        async function fetchMyAPI() {
            var sSearch = "";
            const param2 = "?sSearch=" + val;
            const tukhoa = {
                params: param2,
            };
            const response = await DatHangApi.AutocompleteSanPham.call(null, tukhoa);

            if (response.data !== null) {
                setAutocompleteData1(response.data);
            } else {
                setAutocompleteData1([]);
            }
        }

        fetchMyAPI();
    };

    return (
        <>
            <div
                style={{ position: "relative", width: "100%" }}
                onFocus={() => focusinputkhachhang()}
                onBlur={() => unfocusinputkhachhang()}
            >
                <Autocomplete
                    wrapperProps={{}}
                    autoHighlight={valueBur}
                    selectOnBlur={valueBur}
                    ref={textInput}
                    wrapperStyle={{ flex: "auto" }}
                    inputProps={{
                        className: "form-control input-sm card-autocomplete",
                        readOnly: disEditAll,
                        onKeyDown: (e) => {
                            handleKeyDown(e);
                        },
                    }}
                    menuStyle={{
                        borderRadius: "3px",
                        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                        background: "rgba(255, 255, 255, 0.9)",
                        padding: "2px 0",
                        fontSize: "100%",
                        position: "absolute",
                        overflow: "auto",
                        maxHeight: "250px",
                        lineHeight: "30px",
                        top: "0 !important",
                        left: "0 !important",
                        zIndex: "1000",
                    }}
                    getItemValue={(item) => item.CategoryName}
                    items={autocompleteData1}
                    renderItem={(item, isHighlighted) => {
                        return (
                            <div
                                className="auto-list"
                                style={{
                                    background: isHighlighted ? "lightgray" : "white",
                                    textTransform: "capitalize",
                                }}
                            >
                                {item.IsProduct != null && item.IsProduct
                                    ? item.ProductCode
                                    : item.CategoryName}
                            </div>
                        );
                    }}
                    value={value}
                    onSelect={(value, item) => {
                        onSelectCustomer(value, item);
                    }}
                    onChange={(event, value) => {
                        onChange(event, value);
                    }}
                />
            </div>

            <div class="input-group-append">
                <span
                    class="input-group-text"
                    id="basic-addon4"
                    onClick={(e) => addKyTuPhi()}
                >
                    <a href="#">Ø</a>
                </span>
            </div>
        </>
    );
};
